var render = function (_h,_vm) {var _c=_vm._c;return _c('h1',_vm._g({staticClass:"LmTitle relative leading-tight",class:[
    _vm.props.color,
    _vm.data.class,
    _vm.data.staticClass,
    {
      'text-base': _vm.props.size === 'm',
      'text-l': _vm.props.size === 'l',
      'text-xl': _vm.props.size === 'xl',
      'text-xxl': _vm.props.size === 'xxl',
      'cursor-pointer hover:text-gray-500': _vm.props.clickable,
      'is-new': _vm.props.isNew
    }
  ]},_vm.data.on),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }